module.exports = __webpack_public_path__ + "ddaf53699654527effab92c3dc251e21.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/Ruoff_091114_0043_V1_h.jpg
// module id = 373
// module chunks = 0